import React, { useEffect, useState } from "react";

import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Table } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddandEditPolicy from "../../../../components/modelpopup/AddandEditPolicy";
import DeleteModal from "../../../../components/modelpopup/deletePopup";
import { getData } from "../../../../utils/api";
import { formatDateInTimezone } from "../../../../utils/formatDateInTimezone";
import config from "./../../../../config";
import { companyID } from "../../../../auth";
import api from "../../../../api/axios";
import PolicyAcknowledgementStatusModal from "../../../../components/modelpopup/PolicyAcknowledgementStatusModal";
import Swal from "sweetalert2";

const Policies = () => {
  const company_id = companyID();
  const employeeId = localStorage.getItem("employeeID");
  const [policyData, setPolicyData] = useState([]);
  const [filteredPolicyData, setFilteredPolicyData] = useState([]);
  const [policyEditData, setPolicyEditData] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [deletedId, setDeletedID] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [updateVersion, setUpdateVersion] = useState(false);
  const [policyAcknowledgementData, setPolicyAcknowledgementData] = useState(
    {}
  );

  const [loader, setLoader] = useState(false);

  const fetchCompanyPolicies = async () => {
    try {
      const res = await api.get(`hr/policy-data/${company_id}`);
      const filteredData = res?.data?.results
        ?.reverse()
        .map((policy, index) => ({ ...policy, index: index + 1 }))
        .filter((policy) => policy.status === 1);
      setPolicyData(filteredData);
      setFilteredPolicyData(filteredData);
      const userManualCount = filteredData.filter(
        (policy) => policy.policy_category_name === "User Manual"
      ).length;
      const allPoliciesCount = filteredData.length;
      const companyPoliciesCount = filteredData.filter(
        (policy) => policy.policy_category_name === "Company Policies"
      ).length;

      setStatsData([
        {
          id: 1,
          title: "All Policies",
          value: allPoliciesCount.toString(),
          active: true,
        },
        {
          id: 2,
          title: "User Manual",
          value: userManualCount.toString(),
          active: false,
        },
        {
          id: 3,
          title: "Company Policies",
          value: companyPoliciesCount.toString(),
          active: false,
        },
      ]);
    } catch (error) {
      console.error("Error fetching policy data:", error);
      setPolicyData([]);
      setFilteredPolicyData([]);
      setStatsData([]);
    }
  };

  useEffect(() => {
    try {
      fetchCompanyPolicies();
    } catch (error) {
      console.error(error);
    }
  }, [isEditModalOpen, isModalOpen]);

  const handleDownload = async (filePath) => {
    try {
      const a = document.createElement("a");
      a.href = filePath;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const columns = [
    {
      title: "#",
      dataIndex: "index",
    },
    {
      title: "Policy",
      dataIndex: "policy_name",
    },
    {
      title: "Category",
      dataIndex: "policy_category_name",
    },
    {
      title: "Version",
      dataIndex: "version_number",
      render: (text) => <span className="badge badge-info">{text}</span>,
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      render: (text, record) => formatDateInTimezone(record?.created_at),
    },
    {
      title: "Updated On",
      dataIndex: "updated_at",
      render: (text, record) => formatDateInTimezone(record?.created_at),
    },
    {
      title: "Action",
      render: (record) => (
        <div className="d-flex gap-2 mt-2 justify-content-evenly">
          <button
            className="btn p-0 border-0"
            onClick={() =>
              handleDownload(`${config.IMAGE_URL}${record.policy_file}`)
            }
          >
            <i className="fa fa-download m-r-5 text-primary" title="Download" />
          </button>
          <button
            className="btn p-0 border-0"
            onClick={(e) => {
              e.preventDefault();
              handleEdit(record.id);
              setUpdateVersion(true);
              openEditModal();
            }}
          >
            <i
              className="fa fa-refresh m-r-5 text-primary"
              title="Update Version"
            />
          </button>
          <button
            className="btn p-0 border-0"
            onClick={(e) => {
              e.preventDefault();
              handleEdit(record.id);
              openEditModal();
            }}
          >
            <i
              class="fa-solid fa-users text-primary"
              title="Update Applicable Employees"
            />
          </button>
          <button
            className="btn p-0 border-0"
            onClick={(e) => {
              e.preventDefault();
              setShowModal(true);
              setPolicyAcknowledgementData({
                policyId: record.id,
                policyVersion: record.policy_version_id,
                policyName: record.policy_name,
              });
            }}
          >
            <i
              class="fa-solid fa-handshake text-primary"
              title="Acknowledgement Status"
            />
          </button>
          <button
            className="btn p-0 border-0"
            data-bs-toggle="modal"
            data-bs-target="#delete"
            onClick={() => handleDelete(record.id)}
          >
            <i className="fa fa-trash m-r-5 text-danger" title="Delete" />
          </button>
        </div>
      ),
    },
  ];

  const [selectedDepartmentId, setSelectedDepartmentsId] = useState([]);

  const [selectedDesignationtId, setSelectedDesignationId] = useState([]);

  const handleEdit = (id) => {
    try {
      const policyeditData = async () => {
        const res = await getData(`hr/policy-data-update/${id}`);
        setPolicyEditData(res?.data?.result);
        const response = await getData(`hr/department-desdignation/${id}`);
        if (response?.data?.success == true) {
          const selectededDepartments = response?.data?.result?.map(
            (item) => item.department_id
          );
          const selectededDesignation = response?.data?.result?.map(
            (item) => item.designation_id
          );
          setSelectedDepartmentsId(selectededDepartments);
          setSelectedDesignationId(selectededDesignation);
        }
      };
      policyeditData();
    } catch (err) {}
  };

  useEffect(() => {
    if (!isEditModalOpen && !isModalOpen && !updateVersion) {
      setSelectedDepartmentsId([]);
      setSelectedDesignationId([]);
    }
  }, [isEditModalOpen, updateVersion, isModalOpen]);

  const handleDelete = (id) => {
    setDeletedID(id);
  };

  const confirmDelete = async () => {
    setLoader(true);
    try {
      if (!deletedId) {
        Swal.fire({
          title: "Policy",
          text: "No policy selected for deletion.",
          icon: "warning",
          timer: 1500,
        });
        return;
      }

      await api.put(`hr/policy-data/${deletedId}/${employeeId}`, {});
      Swal.fire({
        title: "Policy",
        text: "Policy deleted successfully",
        icon: "success",
        timer: 1500,
      });
      setDeletedID(null);
      await fetchCompanyPolicies();
    } catch (error) {
      console.error("Error deleting policy:", error);
      Swal.fire({
        title: "Policy",
        text: error?.response?.data?.message || "Something went wrong!",
        icon: "error",
        timer: 1500,
      });
    } finally {
      setLoader(false);
    }
  };

  const filterPolicies = (policyType) => {
    if (policyType === "All Policies") {
      setFilteredPolicyData(policyData);
    } else {
      const filteredPolicies = policyData.filter(
        (policy) => policy?.policy_category_name === policyType
      );
      setFilteredPolicyData(filteredPolicies);
    }

    const updatedStatsData = statsData.map((stat) => ({
      ...stat,
      active: stat.title === policyType,
    }));
    setStatsData(updatedStatsData);
  };

  const { modalOpen } = location.state || {};

  useEffect(() => {
    if (isModalOpen || isEditModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isModalOpen, isEditModalOpen]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const openEditModal = () => {
    setIsEditModalOpen(true);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Policies"
            title="Dashboard"
            subtitle="Policies"
            name="Add Policy"
            page="policies"
            action="create"
            openModal={openModal}
          />

          <div className="row">
            {statsData?.map((stat, index) => (
              <div
                className="col-md-4 d-flex"
                key={index}
                onClick={() => filterPolicies(stat?.title)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={`stats-info w-100 ${
                    stat.active ? "stats-bg" : ""
                  }`}
                >
                  <h6 className={` ${stat.active ? "text-white" : ""}`}>
                    {stat?.title}
                  </h6>
                  {stat?.subText ? (
                    <h4 className={` ${stat.active ? "text-white" : ""}`}>
                      {stat?.value} <span>{stat?.subText}</span>
                    </h4>
                  ) : (
                    <h4 className={` ${stat.active ? "text-white" : ""}`}>
                      {stat?.value}
                    </h4>
                  )}
                </div>
              </div>
            ))}
          </div>

          {loader ? (
            <div className="text-center text-primary">Loading...</div>
          ) : (
            <div className="table-responsive">
              <Table
                className="table-striped"
                columns={columns}
                dataSource={filteredPolicyData}
                rowKey={(record) => record?.id}
                scroll={{ x: true }}
              />
            </div>
          )}
        </div>
      </div>

      {(isModalOpen || isEditModalOpen) && (
        <AddandEditPolicy
          policy={policyEditData}
          setPolicyEditData={setPolicyEditData}
          setPolicyData={setPolicyData}
          selectedDepartmentId={selectedDepartmentId}
          selectedDesignationtId={selectedDesignationtId}
          isModalOpen={isModalOpen}
          isEditModalOpen={isEditModalOpen}
          setIsModalOpen={setIsModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
          updateVersion={updateVersion}
          setUpdateVersion={setUpdateVersion}
        />
      )}
      <DeleteModal Name="Delete Policy" confirmDelete={confirmDelete} />
      {(isModalOpen || isEditModalOpen) && (
        <div className="modal-backdrop fade show"></div>
      )}
      {showModal && (
        <PolicyAcknowledgementStatusModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          policyId={policyAcknowledgementData?.policyId}
          policyVersion={policyAcknowledgementData?.policyVersion}
          policies={filteredPolicyData}
        />
      )}
    </>
  );
};

export default Policies;
